var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.935 7.473h-4.82C24.268 4.397 20.51 2.064 16 2.064s-8.258 2.333-9.115 5.41H3.097A3.097 3.097 0 000 10.57v4.666a3.097 3.097 0 001.373 2.57v8.785a3.097 3.097 0 003.097 3.097h22.71a3.097 3.097 0 003.096-3.097v-8.599A3.097 3.097 0 0032 15.236V9.538a2.065 2.065 0 00-2.065-2.065zM16 4.13c3.22 0 6.018 1.435 6.926 3.344H9.074C9.982 5.563 12.779 4.13 16 4.13zm12.212 22.462a1.032 1.032 0 01-1.033 1.032H4.47a1.032 1.032 0 01-1.032-1.032v-8.258h11.53v1.538a1.032 1.032 0 002.065 0v-1.538h11.18v8.258zm1.723-11.355a1.032 1.032 0 01-1.032 1.032h-11.87V14.71a1.032 1.032 0 10-2.065 0v1.558H3.097a1.032 1.032 0 01-1.032-1.032V10.57a1.032 1.032 0 011.032-1.032h26.838v5.698z"
  })));
}

export default SvgBag;